import * as React from 'react';
import { IDepot } from '../../models';
import { StatusBadge } from '../shared/StatusBadge';
import styles from './DepotsView.module.scss';

export interface IDepotStat {
  depot: IDepot;
  bacsCount: number;
  volumeTotal: number;
  indispoCount: number;
  currentProducts: string[];
  withRestriction: number;
}

export interface IDepotCardProps {
  stat: IDepotStat;
  animDelay: number;
  onClick: () => void;
}

function pickHealth(indispoCount: number, bacsCount: number): 'ok' | 'warn' | 'danger' {
  if (bacsCount === 0) return 'ok';
  const ratio = indispoCount / bacsCount;
  if (ratio >= 0.5) return 'danger';
  if (ratio > 0) return 'warn';
  return 'ok';
}

export const DepotCard: React.FC<IDepotCardProps> = ({ stat, animDelay, onClick }) => {
  const { depot, bacsCount, volumeTotal, indispoCount, currentProducts, withRestriction } = stat;
  const health = pickHealth(indispoCount, bacsCount);

  return (
    <button
      type="button"
      className={`${styles.card} ${styles['health_' + health]}`}
      style={{ animationDelay: `${animDelay}s` }}
      onClick={onClick}
    >
      <div className={styles.cardTopAccent} />

      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>{depot.Title}</h3>
        <span className={`${styles.healthDot} ${styles['dot_' + health]}`} aria-label={health} />
      </div>

      <div className={styles.kpiRow}>
        <div className={styles.kpi}>
          <div className={styles.kpiValue}>{bacsCount}</div>
          <div className={styles.kpiLabel}>bacs</div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiValue}>{(volumeTotal / 1000).toFixed(1)}<span className={styles.kpiUnit}>k m³</span></div>
          <div className={styles.kpiLabel}>capacité</div>
        </div>
        <div className={styles.kpi}>
          <div className={styles.kpiValue}>{indispoCount}</div>
          <div className={styles.kpiLabel}>indispo</div>
        </div>
      </div>

      <div className={styles.productsRow}>
        {currentProducts.length === 0 ? (
          <span className={styles.muted}>— Aucun produit ce mois</span>
        ) : (
          currentProducts.slice(0, 6).map(p => (
            <StatusBadge key={p} contenu={p} compact />
          ))
        )}
        {currentProducts.length > 6 && (
          <span className={styles.muted}>+{currentProducts.length - 6}</span>
        )}
      </div>

      {withRestriction > 0 && (
        <div className={styles.footer}>
          <span className={styles.chip}>{withRestriction} bac{withRestriction > 1 ? 's' : ''} sous restriction</span>
        </div>
      )}

      <div className={styles.cta}>
        Voir les détails <span className={styles.arrow}>→</span>
      </div>
    </button>
  );
};
